//  https://formspree.io/f/xvzygyyz

import React, { useState } from 'react';
import { Box, TextField, MenuItem, Button, Paper, Typography, Select, InputLabel, FormControl, Chip, OutlinedInput } from '@mui/material';

export default function ContactForm({ onSuccess }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    country: '',      // Country shifted up in order
    phone: '',        // Phone shifted down in order
    company: '',
    interest: [],     // Changed to an Empty Array to support multiple selects!
    otherDetails: ''
  });

  const areasOfInterest = [
    { value: 'macro_scenarios', label: 'Macroeconomic Scenarios' },
    { value: 'custom_models', label: 'Client/Custom Models' },
    { value: 'custom_datasets', label: 'Custom Datasets' },
    { value: 'web_apps', label: 'Web Applications/Tools' },
    { value: 'other', label: 'Other (Specify below)' },
  ];

  const handleChange = (prop) => (event) => {
    let value = event.target.value;

    // VALIDATION HOOK FOR PHONE: Strip out everything that isn't a digit, spaces, or a leading '+'
    if (prop === 'phone') {
      value = value.replace(/[^0-9+\s-]/g, '');
    }

    setFormData({ ...formData, [prop]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formPayload = new FormData();
      formPayload.append('Name', formData.name);
      formPayload.append('Email', formData.email);
      formPayload.append('Country', formData.country);
      formPayload.append('Phone', formData.phone);
      formPayload.append('Company', formData.company);
      
      // Converts multiple selections array into a clean comma-separated text string for your email notification
      formPayload.append('Area of Interest', formData.interest.join(', '));
      formPayload.append('Other Details', formData.otherDetails);

      // Your working Formspree URL goes here
      const response = await fetch('https://formspree.io/f/xvzygyyz', {
        method: 'POST',
        body: formPayload,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        alert('Submitted successfully to MEF-we will contact you back v soon.');
        if (onSuccess) onSuccess(); 
        setFormData({ name: '', email: '', country: '', phone: '', company: '', interest: [], otherDetails: '' });
      } else {
        alert('Form submission error. Please check configurations.');
      }
    } catch (error) {
      console.error('Connection Exception Caught:', error);
      alert('Could not complete submission. Please check your network connection.');
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, maxWidth: 600, mx: 'auto', borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, color: 'rgba(84,77,160,1)', fontWeight: 'bold' }}>
        Contact MEF Representative
      </Typography>
      
      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Full Name"
          variant="outlined"
          fullWidth
          required
          value={formData.name}
          onChange={handleChange('name')}
        />

        <TextField
          label="Email Address"
          type="email"
          variant="outlined"
          fullWidth
          required
          value={formData.email}
          onChange={handleChange('email')}
        />

        {/* 1. Country placed BEFORE Phone Number */}
        <TextField
          label="Country"
          variant="outlined"
          fullWidth
          required
          placeholder="e.g. United Kingdom"
          value={formData.country}
          onChange={handleChange('country')}
        />

        {/* 2. Phone input blocked from accepting alphabetical letters */}
        <TextField
          label="Phone Number"
          type="tel"
          variant="outlined"
          fullWidth
          required
          placeholder="e.g. +44 7123 456789"
          value={formData.phone}
          onChange={handleChange('phone')}
          helperText="Only digits, spaces, and '+' international prefixes allowed."
        />

        <TextField
          label="Company Name"
          variant="outlined"
          fullWidth
          required
          value={formData.company}
          onChange={handleChange('company')}
        />

        {/* 3. Re-engineered dropdown selection layout to handle MULTIPLE tags */}
        <FormControl fullWidth required>
          <InputLabel id="multiple-interest-label">Areas of Interest</InputLabel>
          <Select
            labelId="multiple-interest-label"
            multiple
            value={formData.interest}
            onChange={handleChange('interest')}
            input={<OutlinedInput label="Areas of Interest" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => {
                  const labelObj = areasOfInterest.find(opt => opt.value === value);
                  return <Chip key={value} label={labelObj ? labelObj.label : value} size="small" />;
                })}
              </Box>
            )}
          >
            {areasOfInterest.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Other Details"
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          placeholder="Please provide any extra context..."
          value={formData.otherDetails}
          onChange={handleChange('otherDetails')}
        />

        <Button 
          type="submit" 
          variant="contained" 
          size="large"
          sx={{ backgroundColor: 'rgba(84,77,160,1)', '&:hover': { backgroundColor: 'rgba(64,57,140,1)' } }}
        >
          Submit Details
        </Button>
      </Box>
    </Paper>
  );
}